import * as path from "path";
export function testSupported(files) {
    const result = { supported: true, requiredFiles: [] };
    return Promise.resolve(result);
}
export function install(files, destinationPath, gameId, progress) {
    return Promise.resolve({
        message: "Success",
        instructions: files
            .filter((name) => !name.endsWith(path.sep))
            .map((name) => ({
            type: "copy",
            source: name,
            destination: name,
        })),
    });
}
